var _defs, _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.9,
    y: 0.9,
    width: 18.2,
    height: 18.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74,5H5.11c2.58,0,3.45.42,3.45,3.37v3.52c0,1.87-.56,3-3.45,3H2.74ZM5,13.46c1.12,0,1.22-.43,1.22-1.38V8C6.26,6.71,6.2,6.42,5,6.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3,8h0a1.61,1.61,0,0,1,.54-.85,1.5,1.5,0,0,1,1-.3A1.31,1.31,0,0,1,14.28,8h0a1.41,1.41,0,0,1,.51-.85,1.72,1.72,0,0,1,1-.3c1.09,0,1.44.7,1.44,1.67v6.35h-2.1V9.37c0-.35,0-.72-.45-.72s-.43.37-.43.72v5.5h-2.1V9.37c0-.35,0-.72-.45-.72s-.43.37-.43.72v5.5H9.2V6.94h2.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/Dm.155bf913eddcea7907bf7a544c56473e.svg";
export { ForwardRef as ReactComponent };